module.exports = __webpack_public_path__ + "static/img/21.87c81df.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/21.png
// module id = SYX7
// module chunks = 1